// Products sold as personalized / bulk orders are quoted manually because the
// final amount depends on the product, quantity and chosen print options.
export const isCustomizableProduct = (product) => {
  if (!product) return false;

  const categoryName = typeof product.category === 'object'
    ? product.category?.name?.toLowerCase()
    : product.category?.toLowerCase();
  const productName = product.name?.toLowerCase() || '';
  const subcategory = product.subcategory?.toLowerCase() || '';

  const customKeywords = [
    'merchandising', 'por mayor', 'personalizado', 'personalizada',
    'personalizados', 'custom', 'estampado',
    'sublimacion', 'sublimación', 'vinilo', 'dtf'
  ];
  const customCategories = [
    'merchandising', 'por mayor', 'personalizados', 'custom', 'estampados'
  ];

  return customCategories.some(category => categoryName?.includes(category)) ||
    customKeywords.some(keyword =>
      productName.includes(keyword) ||
      subcategory.includes(keyword) ||
      categoryName?.includes(keyword)
    );
};
